module.exports = __webpack_public_path__ + "img/UTBEAR.0a77d48c.png";